import { ContactAddressFormValues } from "../../model/ContactAddressType";
import { Country } from "../../model/PersonalInformationType";
import { UKRAJINA_OZNAKA } from "../../common/data/sifarnik";

const isEmptySelection = (value: unknown): boolean =>
  !value || (typeof value === "object" && Object.keys(value as object).length === 0);

const isUkraine = (country?: Country): boolean => country?.oznaka === UKRAJINA_OZNAKA;

const phoneRegex = /^[0-9]+$/;
const streetRegex = /^[a-zA-ZčćžđšČĆŽĐŠ0-9.\- ]+$/;
const houseNumberRegex = /^[a-zA-ZčćžđšČĆŽĐŠ0-9/ ]+$/;
const cityRegex = /^[a-zA-ZčćžđšČĆŽĐŠ ]+$/;
const postalCodeRegex = /^[a-zA-ZčćžđšČĆŽĐŠ0-9\- ]+$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateContactAddressField = (
  field: string,
  value: string | Country | boolean | null | undefined,
  setFieldError: (field: string, message: string | undefined) => void,
): boolean => {
  let error: string | undefined;

  switch (field) {
    case "telefonPredbroj": {
      const stringValue = typeof value === "string" ? value : "";
      if (stringValue && !phoneRegex.test(stringValue)) {
        error = "common.validation-error.type.number";
      }
      break;
    }
    case "telefon": {
      const stringValue = typeof value === "string" ? value : "";
      if (stringValue) {
        if (!phoneRegex.test(stringValue)) {
          error = "common.validation-error.type.number";
        } else if (stringValue.length < 7 || stringValue.length > 20) {
          error = "contact-address-page.phone-number-field.validation-error.length";
        }
      }
      break;
    }
    case "mobitelPredbroj": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!phoneRegex.test(stringValue)) {
        error = "common.validation-error.type.number";
      }
      break;
    }
    case "mobitel": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!phoneRegex.test(stringValue)) {
        error = "common.validation-error.type.number";
      } else if (stringValue.length < 7 || stringValue.length > 20) {
        error = "contact-address-page.mobile-number-field.validation-error.length";
      }
      break;
    }
    case "mailAdresa": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!emailRegex.test(stringValue)) {
        error = "common.validation-error.type.email";
      }
      break;
    }
    case "ulica": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!streetRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-space-line-dot";
      } else if (stringValue.length > 35) {
        error = "contact-address-page.address-field.validation-error.max-length";
      }
      break;
    }
    case "kucniBr": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!houseNumberRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-slash";
      } else if (stringValue.length > 16) {
        error = "contact-address-page.house-number-field.validation-error.max-length";
      }
      break;
    }
    case "mjesto": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!cityRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-space";
      } else if (stringValue.length > 35) {
        error = "contact-address-page.location-field.validation-error.max-length";
      }
      break;
    }
    case "postanskiBroj": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!postalCodeRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-space-line";
      } else if (stringValue.length > 16) {
        error = "contact-address-page.zip-code-field.validation-error.max-length";
      }
      break;
    }
    case "drzava": {
      if (isEmptySelection(value)) {
        error = "common.validation-error.required";
      }
      break;
    }
    case "dostavaUlica": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!streetRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-space-line-dot";
      }
    }
      break;
    case "dostavaKucniBr": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!houseNumberRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-slash";
      } else if (stringValue.length > 16) {
        error = "contact-address-page.house-number-field.validation-error.max-length";
      }
      break;
    }
    case "dostavaMjesto": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!cityRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-space";
      } else if (stringValue.length > 35) {
        error = "contact-address-page.location-field.validation-error.max-length";
      }
      break;
    }
    case "dostavaPostanskiBroj": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!postalCodeRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-space-line";
      } else if (stringValue.length > 16) {
        error = "contact-address-page.zip-code-field.validation-error.max-length";
      }
      break;
    }
    case "dostavaDrzava": {
      if (isEmptySelection(value)) {
        error = "common.validation-error.required";
      }
      break;
    }
    case "boravisteUlica": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!streetRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-space-line-dot";
      }
      break;
    }
    case "boravisteKucniBr": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!houseNumberRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-slash";
      } else if (stringValue.length > 16) {
        error = "contact-address-page.house-number-field.validation-error.max-length";
      }
      break;
    }
    case "boravisteMjesto": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!cityRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-space";
      } else if (stringValue.length > 35) {
        error = "contact-address-page.location-field.validation-error.max-length";
      }
      break;
    }
    case "boravistePostanskiBroj": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!postalCodeRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-space-line";
      } else if (stringValue.length > 16) {
        error = "contact-address-page.zip-code-field.validation-error.max-length";
      }
      break;
    }
    case "boravisteDrzava": {
      if (isEmptySelection(value)) {
        error = "common.validation-error.required";
      }
      break;
    }
    case "trecaUlica": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!streetRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-space-line-dot";
      }
      break;
    }
    case "trecaKucniBr": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!houseNumberRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-slash";
      } else if (stringValue.length > 16) {
        error = "contact-address-page.house-number-field.validation-error.max-length";
      }
      break;
    }
    case "trecaMjesto": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!cityRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-space";
      } else if (stringValue.length > 35) {
        error = "contact-address-page.location-field.validation-error.max-length";
      }
      break;
    }
    case "trecaPostanskiBroj": {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue.trim()) {
        error = "common.validation-error.required";
      } else if (!postalCodeRegex.test(stringValue)) {
        error = "common.validation-error.type.letter-number-space-line";
      } else if (stringValue.length > 16) {
        error = "contact-address-page.zip-code-field.validation-error.max-length";
      }
      break;
    }
    case "trecaDrzava": {
      if (isEmptySelection(value)) {
        error = "common.validation-error.required";
      }
      break;
    }
    case "drzavaRegija":
    case "dostavaDrzavaRegija":
    case "boravisteDrzavaRegija":
    case "trecaDrzavaRegija": {
      if (isEmptySelection(value)) {
        error = "common.validation-error.required";
      }
      break;
    }
  }

  setFieldError(field, error);
  return error === undefined;
};

export const validateContactAddressForm = (
  values: ContactAddressFormValues,
  setFieldError: (field: string, message: string | undefined) => void,
): boolean => {
  let isValid = true;

  const requiredFields = [
    "mobitelPredbroj",
    "mobitel",
    "mailAdresa",
    "ulica",
    "kucniBr",
    "mjesto",
    "postanskiBroj",
    "drzava",
  ];

  if (isUkraine(values.drzava)) {
    requiredFields.push("drzavaRegija");
  }

  for (const field of requiredFields) {
    const value = values[field as keyof ContactAddressFormValues];
    if (!validateContactAddressField(field, value, setFieldError)) {
      isValid = false;
    }
  }

  if (values.dostavaDrugaAdresa) {
    const dostavaFields = [
      "dostavaUlica",
      "dostavaKucniBr",
      "dostavaMjesto",
      "dostavaPostanskiBroj",
      "dostavaDrzava",
    ];
    if (isUkraine(values.dostavaDrzava)) {
      dostavaFields.push("dostavaDrzavaRegija");
    }
    for (const field of dostavaFields) {
      const value = values[field as keyof ContactAddressFormValues];
      if (!validateContactAddressField(field, value, setFieldError)) {
        isValid = false;
      }
    }
  }

  if (values.boraviste) {
    const boravisteFields = [
      "boravisteUlica",
      "boravisteKucniBr",
      "boravisteMjesto",
      "boravistePostanskiBroj",
      "boravisteDrzava",
    ];
    if (isUkraine(values.boravisteDrzava)) {
      boravisteFields.push("boravisteDrzavaRegija");
    }
    for (const field of boravisteFields) {
      const value = values[field as keyof ContactAddressFormValues];
      if (!validateContactAddressField(field, value, setFieldError)) {
        isValid = false;
      }
    }
  }

  if (values.trecaAdresa && values.dostavaDrugaAdresa && !values.boraviste) {
    const trecaFields = [
      "trecaUlica",
      "trecaKucniBr",
      "trecaMjesto",
      "trecaPostanskiBroj",
      "trecaDrzava",
    ];
    if (isUkraine(values.trecaDrzava)) {
      trecaFields.push("trecaDrzavaRegija");
    }
    for (const field of trecaFields) {
      const value = values[field as keyof ContactAddressFormValues];
      if (!validateContactAddressField(field, value, setFieldError)) {
        isValid = false;
      }
    }
  }

  return isValid;
};